import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const BlogCard = ({ post }) => {
  return (
    <article className="group py-8 border-b border-slate-800/50 last:border-0 relative">
      {/* Hover Highlight Effect */}
      <div className="absolute inset-0 bg-slate-800/0 group-hover:bg-slate-800/20 -mx-6 px-6 rounded-2xl transition-colors duration-300 pointer-events-none"></div>
      
      <div className="relative flex flex-col md:flex-row md:items-baseline gap-4 md:gap-8">
        {/* Meta Data (Left Column on Desktop) */}
        <div className="md:w-48 shrink-0 flex flex-row md:flex-col gap-3 text-sm text-slate-500 font-mono">
          <time dateTime={post.date}>{post.date}</time>
          <div className="flex items-center gap-1.5 text-slate-400">
            <SafeIcon icon={FiIcons.FiClock} className="text-emerald-500/70" /> {post.readTime}
          </div>
          <span className="hidden md:inline-block text-purple-400">{post.category}</span>
        </div>

        {/* Content */}
        <div className="flex-grow">
          <Link to={`/blog/${post.slug}`} className="block">
            <h3 className="text-2xl font-bold text-slate-200 mb-3 group-hover:text-emerald-400 transition-colors">
              {post.title}
            </h3>
            <p className="text-slate-400 leading-relaxed mb-4">
              {post.excerpt}
            </p>
            <div className="flex items-center text-emerald-400 font-medium text-sm gap-1 group-hover:gap-2 transition-all">
              Read Article <SafeIcon icon={FiIcons.FiArrowRight} />
            </div>
          </Link>
        </div>
      </div>
    </article>
  );
};

export default BlogCard;